/**
 * This is the termscond routes configuration.
 * Only configure routes in this file.
 * @memberOf termscond Module
 * @namespace termscond Routes
 */
import termscondTemplate from './termscond.html';

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf termscond Module.termscond Routes
 * @ngInject
 */
var config = function ($stateProvider) {

    /* Create the termscond state and assign the template and controller. */
    $stateProvider
    .state('login.termscond', {
      url: '/terms',
      template: termscondTemplate,
      controller: 'termscondController',
      controllerAs: 'termscondController'
    });
};

export default config;



// WEBPACK FOOTER //
// ./src/login/termscond/termscond.route.js